import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['5 Master Workbooks — 300 pages', '4 Expert Bonuses — 160+ pages', '460+ pages of print-ready content', 'Instant download — printable PDF', 'NGSS aligned + AP Chemistry compatible', 'Available worldwide', 'One-time payment — no subscription', '30-day money-back guarantee'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-ink px-5 py-14 sm:py-24" data-id="element-41" data-mp="20suhlizj8q8p">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-42" data-mp="1w01f71rjdtzs">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-43" data-mp="1i1bezd9f7e77">
          Your lessons prepared. Your students engaged. Your Mondays transformed.
        </h2>
        <p className="mt-4 text-lg font-medium text-cobalt sm:text-xl" data-id="element-44" data-mp="3nswkwesnhion">
          Visual Chemistry Master System™
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-45" data-mp="3sky1gcwupvkh">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-46" data-mp="3dwtid7tvzi16">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/20 text-cobalt" data-id="element-47" data-mp="3ittjr5fsjwly">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="afupc88gwjak" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-49" data-mp="fcbgzcevlfse">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-50" data-mp="g3z4iqxwqga">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-51" data-mp="5enhk96brk3w">$423 USD</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-cobalt sm:text-7xl" data-id="element-52" data-mp="2l5jjauvnlgwy">
            $27 USD
          </span>
        </div>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(22, 163, 74, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-cta-green px-6 py-4 text-base font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/40 sm:text-lg" data-id="element-53" data-mp="2q3bdjvjrtf4b">
          YES — I WANT THE COMPLETE SYSTEM
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-54" data-mp="1ycap63ph7411">
          Instant Access · One-Time Payment · Worldwide · 30-Day Guarantee
        </p>
      </motion.div>
    </section>;
}